export interface LoginRequest {
  username: string
  password: string
}

export interface LoginChallengeResponse {
  status: '2fa_required'
  challenge_token: string
  expires_in: number
}

export interface TokenResponse {
  access_token: string
  token_type: 'bearer'
  expires_in: number
}

export type LoginResponse = LoginChallengeResponse | TokenResponse

export interface TOTPVerifyRequest {
  challenge_token: string
  totp_code?: string
  backup_code?: string
}

export interface UserResponse {
  id: number
  username: string
  timezone: string
  emergency_mode_active: boolean
  emergency_mode_activated_at: string | null
}

export function is2FARequired(res: LoginResponse): res is LoginChallengeResponse {
  return 'status' in res && res.status === '2fa_required'
}
